import { lazy } from "react";

export type { DateControlProps } from "./DateControl.component";

export const DateControl = lazy(() => import("./DateControl.component"));
